<template>
  <div class="navi">
    <div class="navi_container">
    <ul :style="{ height: naviHeight}">
      <li v-for="(iterm,val) in navi_items" @click="navi_go(val, $event)" :id="val" :class="{'selected_li':val==currentPage}">
        <a>{{iterm}}</a>
      </li>
    </ul>
  </div>
  </div>
</template>

<script>

export default {
  name: 'navi',
  props:["currentPage","naviHeight"],

  data () {
    return {
      title:"",
      navi_items: {
        '':'Home',
        'online':'Online Tool',
        'download':'Download',
        // 'tutorial':'Tutorial',
        'follow':'About us'
      },
      links:{
        'follow':'http://pmglab.top/homepage',
        // 'download':'https://mailsysueducn-my.sharepoint.com/:u:/g/personal/limiaoxin_mail_sysu_edu_cn/EZxHcXiZfQRIi6T8jezSqo8Bf8-mfJZK4N0adtB8J6I79Q',
        // 'manual':'https://pmg-lab-docs.readthedocs.io/en/latest/KGGSEE_doc/KGGSEE.html',
      },
      // currentPage:''
    }
  },
  methods:{
    navi_go:function(navi_iterm){
      if(this.links.hasOwnProperty(navi_iterm)){
        window.open(this.links[navi_iterm])
      }else{
        this.$router.push({path:'/'+navi_iterm});
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navi {
  /* background:#005826; */
  margin: 0;
  position: fixed;
  top: 95px;
  left: 10px;
  width:200px;
  padding: 0;

}
.navi_container{

  /* height: 100%; */
  /* margin: 0 auto; */
}

img {
  height: 70px;
  margin: 5px 20px 5px 30px;
  float:left;
}
p {

  float: left;
  color: #FFFFFF;
  font-size: 18px;
}

ul {
  margin: 0;
  padding: 0px 0px;
  height: 100%;
  /* border: solid #054719 3px; */
  list-style: none;
  /* height:500px; */
  margin: 0px 10px;
  background: #EFEFEF;
    /* border-bottom: solid #054719 2px; */
    /* border: solid #E1EAEA 1px; */
}

li {
  /* height: 100%; */
  vertical-align: middle;
  height: 40px;
  line-height:40px;
  /* float: left; */
  padding-left: 20px;
  padding-right: 20px;
  color:#054719;
    /* color:#000000; */
  font-size: 16px;
  /* border-top: solid #054719 2px; */
  /* border-bottom: solid #054719 2px; */
  border-bottom: solid #E1EAEA 2px;
  
  /* border-left: solid #666666; */
}

li:hover{
  color:#FFFFFF;
  background:  #005826;
  cursor:pointer;
  /* border-bottom: solid #005826 4px;
  box-sizing: border-box; */
}


.selected_li{
  color:#FFFFFF;
  background:  #005826;
}
</style>



// WEBPACK FOOTER //
// src/components/navigate.vue